import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTaaBerry'
})
export class RemoveTaaBerryPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    // case insensitive, remove 'TAA' and 'BERRY' from the string
    if (typeof value === 'string') {
      return value.replace(/TAA/gi, '').replace(/BERRY/gi, '').trim();
    }

    return value;
  }

}
